import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/ bootstrap.bundle.min.js '
import 'bootstrap/dist/js/bootstrap.min.js'
// import 'font-awesome/css/font-awesome.min.css'
// import 'lib-flexible'
import VideoPlayer from 'vue-video-player'
import api from './api/index.js'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import directives from './utils/directive.js'
Vue.use(directives)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.use(VideoPlayer)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
Vue.config.productionTip = false

Vue.prototype.$api = api
    // Vue.prototype.$path = 'http://10.10.10.68:8080'
Vue.prototype.$path = 'http://www.shanxifenghang.com/web'
Vue.prototype.$paths = 'http://www.shanxifenghang.com/web'
    // Vue.prototype.$path = 'https://ceshi.yibaojie.cn'
    // Vue.prototype.$path = 'http://www.fenghang-sx.com/web'
    // Vue.prototype.$paths = 'http://www.fenghang-sx.com/web'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')